import { Component } from '@angular/core';

@Component({
  selector: 'laps-unauthorized',
  template: `<p>Unauthorized...</p>`,
})
export class UnauthorizedComponent {}
